export const LocalStorage = {
  /**
     * Api Token
     */
  setApiToken(token) {
    localStorage.setItem('api_token', token);
  },
  getApiToken() {
    return localStorage.getItem('api_token');
  },
  removeApiToken() {
    localStorage.removeItem('api_token');
  },

  /**
     * Auth User
     */
  setAuthUser(authUser) {
    localStorage.setItem('auth_user', JSON.stringify(authUser));
  },
  getAuthUser() {
    return JSON.parse(localStorage.getItem('auth_user'));
  },
  removeAuthUser() {
    localStorage.removeItem('auth_user');
  },

  /**
     * AdminMode
     */
  setAdminMode(is_admin) {
    localStorage.setItem('admin_mode', is_admin);
  },
  getAdminMode() {
    return JSON.parse(localStorage.getItem('admin_mode'));
  },
  removeAdminMode() {
    localStorage.removeItem('admin_mode');
  },


  /**
   * Debugging Mode
   */
  getDebuggingMode() {
    return JSON.parse(localStorage.getItem('debugging_mode'));
  },

  clear() {
    localStorage.clear();
  },
};

export default LocalStorage;
